import { useRouter } from 'next/router';

import { FEATURE_TOGGLES, LOCALES } from '../constants';
import { useStore } from '../zustand/stores';

export const useIsGenAnswer = () => {
  const featureTogglesSlice = useStore(
    (state) => (state.featureTogglesSlice));

  const isAiServicesDisabled = featureTogglesSlice[FEATURE_TOGGLES.DISABLE_AI_SERVICES];

  const { locale } = useRouter();

  return (locale === LOCALES.EN && !isAiServicesDisabled);
};
